import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { TypographyStyle, TypographyWeight, ThemeStyle } from '@treelab/panda';

import { Typography } from '../../../Typography';

const SpaceAbsent: React.FC<WrappedComponentProps> = ({ intl: { formatMessage } }) => (
  <div
    style={{
      padding: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      boxSizing: 'border-box',
    }}
  >
    <Typography weight={TypographyWeight.Medium} type={TypographyStyle.P2} theme={ThemeStyle.gray}>
      {formatMessage({ id: 'space.error.deleted' })}
    </Typography>
  </div>
);
export default injectIntl(SpaceAbsent);
